type TryToGetNumberType = <D extends any = number>(
	input: unknown,
	defaultValue?: D | number
) => number | D

export const tryToGetNumber: TryToGetNumberType = (input, defaultValue = 0) => {
	if (typeof input === 'number') return input
	if (typeof input === 'string') {
		const probablyNumber = parseFloat(input.replaceAll(/\s/g, ''))
		if (isNaN(probablyNumber)) return defaultValue
		return probablyNumber
	}
	return defaultValue
}
